/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TenderStates = 'Complete' | 'Approval' | 'CollectiveSouring' | 'Publication' | 'Offering' | 'Rating' | 'Auction' | 'Decisioning' | 'CommunicationAward' | 'Closing' | 'Finished' | 'Cancelled' | 'Recalled' | 'Incomplete';

export const TenderStates = {
    Complete: 'Complete' as TenderStates,
    Approval: 'Approval' as TenderStates,
    CollectiveSouring: 'CollectiveSouring' as TenderStates,
    Publication: 'Publication' as TenderStates,
    Offering: 'Offering' as TenderStates,
    Rating: 'Rating' as TenderStates,
    Auction: 'Auction' as TenderStates,
    Decisioning: 'Decisioning' as TenderStates,
    CommunicationAward: 'CommunicationAward' as TenderStates,
    Closing: 'Closing' as TenderStates,
    Finished: 'Finished' as TenderStates,
    Cancelled: 'Cancelled' as TenderStates,
    Recalled: 'Recalled' as TenderStates,
    Incomplete: 'Incomplete' as TenderStates
};

